// frontend/packs/verification-modal.js

import 'sessions/signup_email_verification_component/signup_email_verification_component.css';

import SignupEmailVerificationController from 'sessions/signup_email_verification_component/signup-email-verification-controller';

window.EezyStimulusApplication.register('signup-email-verification', SignupEmailVerificationController);
